var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mapa-con-marcador',{attrs:{"title":"Seleccione la Ubicación","isMobile":_vm.isMobile,"height":630},on:{"locationSaved":_vm.handleLocationSaved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }